import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

export interface DataHubLogListGridActionCellRendererParams extends ICellRendererParams {
    viewDetails: (params: DataHubLogListGridActionCellRendererParams) => void;
}

@Component({
    selector: 'data-hub-log-grid-action-cell',
    template:
        `@if (dataHubSummaryLog) {
  <button type="button"
    class="ace-btn btn-primary has-icon grid-action-button"
    (click)="params.viewDetails(params)"
    helpTooltip
    helpContentId="app.view"
    position="bottom">
    <i class="fa fa-pencil"></i>
  </button>
}`,
    standalone: false
})
export class DataHubLogListGridActionCellRendererComponent implements ICellRendererAngularComp {
    params: DataHubLogListGridActionCellRendererParams;
    dataHubSummaryLog: Core.DataHubSummaryLogModel;

    agInit(params: DataHubLogListGridActionCellRendererParams): void {
        this.params = params;
        this.dataHubSummaryLog = params.data as Core.DataHubSummaryLogModel;
    }

    refresh(): boolean {
        return false; // tells grid to handle refreshing
    }
}
